import React from "react";
import { FaArrowRight, FaGift, FaTruck } from "react-icons/fa";

const offers = [
  {
    id: 1,
    title: "Free Delivery",
    subtitle: "Free delivery for orders above BDT 999",
    route: "/products/home-living",
  },
  {
    id: 2,
    title: "Sell Offer",
    subtitle: "Free delivery over BDT 1,499",
    route: "/products/sports",
  },
  {
    id: 3,
    title: "Flash Sale",
    subtitle: "Free delivery today only",
    route: "/products/beauty",
  },
  {
    id: 4,
    title: "Back-to-School Picks",
    subtitle: "Free delivery over BDT 1,499",
    route: "/products/fashion",
  },
];

export default function OffersSection() {
  return (
    <section className="sm:mt-10 mt-5 px-4 sm:px-6">
      <div className="rounded-2xl bg-gradient-to-r from-[#065a82]  to-[#1b3b6f] p-4 sm:p-6">
        <div className="mb-4 flex items-center justify-between">
          <div>
            <h3 className="text-xl font-bold text-white sm:text-2xl">
              Offers
            </h3>
            <p className="text-sm text-white sm:text-base">
              Save more with getting offers.
            </p>
          </div>
        </div>

        <div className="grid sm:grid-cols-2 grid-cols-1 sm:gap-3 gap-2">
          {offers.map((offer) => (
            <button
              key={offer.id}
              type="button"
              onClick={() => (window.location.hash = offer.route)}
              className="flex items-start gap-3 rounded-md border border-emerald-200/80 bg-gray-100 sm:p-4 p-2 text-left shadow-sm transition hover:-translate-y-0.5 hover:shadow-md"
            >
              <span className="mt-0.5 inline-flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-emerald-600 text-white">
                <FaTruck />
              </span>
              <div className="min-w-0">
                <p className="line-clamp-1 text-sm font-bold text-slate-800 sm:text-base">
                  {offer.title}
                </p>
                <p className="sm:mt-1 mt-0 text-xs text-slate-600 sm:text-sm">
                  {offer.subtitle}
                </p>
                <span className="sm:mt-2 mt-1 inline-flex items-center gap-1 text-xs font-semibold text-emerald-700 sm:text-sm">
                  <FaGift />
                  Shop Offer
                </span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}
